import { useEffect, useState } from "react";
import {
  discardUnsavedNativeCapture,
  hasNativeCaptureRecoveryError,
  NATIVE_CAPTURE_CHANGED,
  NATIVE_CAPTURE_ERROR,
  retryNativeCapture
} from "../services/platform/nativeCapture";

export function NativeCaptureRecoveryNotice(): JSX.Element | null {
  const [failed, setFailed] = useState(hasNativeCaptureRecoveryError);
  const [busy, setBusy] = useState(false);
  const [confirmDiscard, setConfirmDiscard] = useState(false);
  const [error, setError] = useState<string>();
  useEffect(() => {
    const update = () => setFailed(hasNativeCaptureRecoveryError());
    update();
    window.addEventListener(NATIVE_CAPTURE_CHANGED, update);
    window.addEventListener(NATIVE_CAPTURE_ERROR, update);
    return () => {
      window.removeEventListener(NATIVE_CAPTURE_CHANGED, update);
      window.removeEventListener(NATIVE_CAPTURE_ERROR, update);
    };
  }, []);

  async function recover(discard = false): Promise<void> {
    setBusy(true);
    setError(undefined);
    try {
      if (discard) await discardUnsavedNativeCapture();
      else await retryNativeCapture();
      setConfirmDiscard(false);
    } catch {
      setError("The photo is still unavailable. Check free storage, or discard this selection and choose the photo again.");
    } finally {
      setBusy(false);
    }
  }

  if (!failed) return null;
  return (
    <section className="screen" aria-label="Photo recovery">
      <div className="notice notice--warning" role="alert">
        <p>{confirmDiscard ? "Discard this unsaved photo selection? Photos already saved in reports will stay." : "A selected photo could not be saved. You can retry or choose it again."}</p>
        {error && <p>{error}</p>}
        <div className="button-row">
          {confirmDiscard ? (
            <>
              <button className="button" type="button" disabled={busy} onClick={() => setConfirmDiscard(false)}>Keep selection</button>
              <button className="button" type="button" disabled={busy} onClick={() => void recover(true)}>Discard unsaved photo</button>
            </>
          ) : (
            <>
              <button className="button button--primary" type="button" disabled={busy} onClick={() => void recover()}>Retry saving</button>
              <button className="button" type="button" disabled={busy} onClick={() => setConfirmDiscard(true)}>Discard selection</button>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
